import { SvgIcon, SvgIconProps } from "@mui/material";

export const BrandingIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      aria-label="branding"
    >
      <path
        stroke="#E287D9"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M11.999 6.375a.272.272 0 0 0-.273.275.275.275 0 1 0 .273-.275m-5.075 5.624a.275.275 0 1 0-.548.004.275.275 0 0 0 .548-.004m9.053-3.977a.275.275 0 1 0-.385.39.275.275 0 0 0 .385-.39M8.41 15.589a.275.275 0 1 0-.385.39.275.275 0 0 0 .385-.39m.001-7.179a.275.275 0 1 0-.39-.385.275.275 0 0 0 .39.385"
      />
      <path
        stroke="#E287D9"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M12 21a9 9 0 0 1-8.996-9.255c.13-4.696 4.045-8.611 8.741-8.741A9 9 0 0 1 21 12v1a2 2 0 0 1-2 2h-2.063a2 2 0 0 0-1.923 2.549l.257.901A2 2 0 0 1 13.349 21H12Z"
        clip-rule="evenodd"
      />
    </svg>
    ;
  </SvgIcon>
);
